/**
 * Determines the offset between all offers and the min/max offers fetched
 * @returns a number (between 0 and 1) that represents the rating
 */
export const getPriceBarRating = (offerPriceTotal: number, max: number, min: number): number =>
	(100 - (100 * (offerPriceTotal - max)) / (min - max)) / 100;
